module.exports = __webpack_public_path__ + "img/twoSteps.51972e7b.png";